export default {"src":"/_next/static/media/icon-stats-critical-damage.99227902.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};